export const moduleNamespace = 'mercury-fe';
export const routeNamespace = '/agsets';
